import {FormuleProductEnum} from "@shared/constants/formule-product.enum";
import { FormuleEnum }      from '@shared/enums/formule.enum';
import { ESTATE_FORMULE }     from '@shared/enums/ESTATE_FORMULE';

export type contractValidators = {
  key: string;
  validators: any[];
  value: string | number;
}

export const SEUILS = [
  {
    key:   '1',
    value: '1',
  },
  {
    key:   '10',
    value: '10'
  },
  {
    key:   '30',
    value: '30'
  }
]

export const PRECO_SUR_MESURE = [
    {
        id:      FormuleEnum.HEADER,
        header:  "Couverture",
        header2: "SUR-MESURE",
        style:   {
            "background-color": "#EEEEEE",
            "text-align":       "center",
            "font-weight":      'bold'
        }
    },
    {
        id:          FormuleProductEnum.FORMULE_GROUPAMA_SECURITE,
        header:      "€",
        extension:   "€",
        style:       {
            "border-top": "6px solid #01AE99",
            "text-align": "center"
        },
        color:       "#01AE99",
        img:         'assets/img/preco/1picto-interdit-securite.svg',
        isElligible: ESTATE_FORMULE.SHOW,
    },
    {
        id:          FormuleProductEnum.FORMULE_GROUPAMA_SECURITE_RENTE_EDUCATION,
        header:      "€",
        extension:   "€",
        style:       {
            "border-top": "6px solid #8dbe3b",
            "text-align": "center"
        },
        color:       "#8dbe3b",
        img:         'assets/img/preco/1picto-interdit-rente-educ.svg',
        isElligible: ESTATE_FORMULE.SHOW,
    },
    {
        id:          FormuleProductEnum.FORMULE_GROUPAMA_GAV,
        header:      "%",
        extension:   "%",
        style:       {
            "border-top": "6px solid #0085ab",
            "text-align": "center"
        },
        color:       "#0085ab",
        img:         'assets/img/preco/1picto-interdit-gav.svg',
        isElligible: ESTATE_FORMULE.SHOW,
    },
    {
        id:          FormuleProductEnum.FORMULE_GROUPAMA_SERENITE_OBSEQUES,
        header:      "€",
        extension:   "€",
        style:       {
            "border-top": "6px solid #e83462",
            "text-align": "center"
        },
        color:       "#e83462",
        img:         'assets/img/preco/1picto-interdit-obseques.svg',
        isElligible: ESTATE_FORMULE.SHOW,
    }
]

